import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Product } from '../../interfaces/Product/Product';
import { ProductOptionValue } from '../../interfaces/Product/ProductOption';
import { sharedColors } from '../../utils/Style';

type ProductNotesProps = {
  product: Product;
  option?: ProductOptionValue;
};

export const ProductNotes = ({ product }: ProductNotesProps) => {
  const keyStyles = {
    fontSize: '14px',
    color: sharedColors.gray4,
  };

  const valueStyles = {
    fontSize: '14px',
    color: sharedColors.gray6,
    fontWeight: 600,
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography sx={keyStyles}>
        Marka:{' '}
        <Link
          to={`/marka/${product.brand.slug}`}
          style={{ textDecoration: 'none' }}
        >
          <Typography component='span' sx={valueStyles}>
            {product.brand.name}
          </Typography>
        </Link>
      </Typography>

      {!!product.skt && (
        <Typography sx={keyStyles}>
          Son kullanma tarihi:{' '}
          <Typography component='span' sx={valueStyles}>
            {product.skt}
          </Typography>
        </Typography>
      )}

      <Typography sx={keyStyles}>
        SKU:{' '}
        <Typography
          component='span'
          sx={{ fontSize: '14px', color: sharedColors.gray4 }}
        >
          {product.sku}
        </Typography>
      </Typography>
    </Box>
  );
};
